import {Dispatch, SetStateAction, useState} from "react";
import {storage} from '../../config'
import {ref, getDownloadURL, uploadBytes} from "firebase/storage";

import styled from "styled-components";

export const ModalWrapper = styled.div`
  position: relative;
  margin: 20px 0;
  z-index: 999;
  display: flex;
  width: 100%;
  height: 100%;
`

export const AdminContent = styled.div`

  color: black;
  width: 100%;
  display: flex;
  flex-direction: column;

  .touched {
    box-sizing: border-box;
    outline: 4px #53c453 solid;
  }

  input {
    color: black;
    font-weight: 600;
    font-size: 16px;
    width: 100%;
    border: none;
    margin: 0;
    margin-top: 10px;
    padding: 0;
  }
    
  }
  button{
    background-color: #E44432;
    color: white;
    font-weight: 600;
    font-size: 16px;
    width: 120px;
    border: none;
    padding: 10px;
    margin-top: 10px;
    border-radius: 15px;
    :hover{
      background-color: #88281c;
    }
  }
`
export const ImageContent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  
  @media (max-width: 768px;){
  padding: 20px;
}
`

export const DisplayImg = styled.div`
  background-color: #ECEFF1;
  margin-right: 10px;
  margin-bottom: 10px;`

export const Image = styled.img`
    height: 80px;
    max-width: 200px;
`

interface Props {
    imgUrls: string[] | null;
    setImgUrls: Dispatch<SetStateAction<string[] | null>>;
    setImgModal:Dispatch<SetStateAction<boolean>>;
}


function ImagesModal(props: Props) {

    const [imageUpload, setImageUpload] = useState<File | null>(null);

    const uploadFile = () => {
        if (imageUpload == null) return;
        const imageRef = ref(storage, `images/${imageUpload.name}`);
        uploadBytes(imageRef, imageUpload).then((snapshot) => {
            getDownloadURL(snapshot.ref).then((url) => {
                if (props.imgUrls !== null) {
                    // @ts-ignore
                    props.setImgUrls((prev) => [...prev, url]);
                } else {
                    props.setImgUrls([url]);
                }
            });
        });
    };

    return (
        <ModalWrapper>
            <AdminContent>
                <input
                    type="file"
                    accept="image/jpeg"
                    onChange={(event) => {
                        if (event.target.files !== null) {
                            setImageUpload(event.target.files[0]);
                        }}}/>
                <button onClick={(e)=>{
                    e.preventDefault();
                    uploadFile()}}>
                    Wgraj plik </button>
            </AdminContent>
        </ModalWrapper>
    );
}

export default ImagesModal
